import { styled } from '../../../common/ui'
import { theme } from '../theme'

export const TextArea = styled.textarea`
  border: 3px solid black;
  padding: 8px;
  font-size: 16px;
  font-weight: bold;
  outline: 0;
  color: #000;
  width: 100%;
  max-width: 500px;
  background: ${theme.colors.grayLight};
  &:hover {
    border: 3px solid ${theme.colors.blue};
  }
  &:active,
  &:focus {
    border: 3px solid ${theme.colors.blue};
    background: #fff;
  }

  &[data-has-error='1'] {
    border: 3px solid ${theme.colors.red};
  }
`
